import { Message } from './types';

// Timestamps relative to 2026-08-29
const d = (offsetMinutes: number) => {
  const base = new Date('2026-08-29T11:40:32Z');
  base.setMinutes(base.getMinutes() - offsetMinutes);
  return base.toISOString();
};

const yesterday = (h: number, m: number) => {
  const base = new Date('2026-08-28T00:00:00Z');
  base.setHours(h, m, 0, 0);
  return base.toISOString();
};

export const INITIAL_MESSAGES: Message[] = [
  {
    id: 'msg-001',
    senderId: 'alex',
    text: 'uy kumain ka na ba? 😄',
    timestamp: yesterday(9, 12),
    type: 'text',
    reactions: []
  },
  {
    id: 'msg-002',
    senderId: 'me',
    text: 'hindi pa haha busy pa ko dito',
    timestamp: yesterday(9, 14),
    status: 'read',
    type: 'text',
    reactions: []
  },
  {
    id: 'msg-003',
    senderId: 'me',
    text: 'ikaw na lang muna kumain',
    timestamp: yesterday(9, 14),
    status: 'read',
    type: 'text',
    reactions: []
  },
  {
    id: 'msg-004',
    senderId: 'alex',
    text: 'yawa HAHAHAHA sige na kain na tayo',
    timestamp: yesterday(9, 16),
    type: 'text',
    reactions: [{ emoji: '😂', count: 1, byMe: true }]
  },
  {
    id: 'msg-005',
    senderId: 'alex',
    text: 'may ulam na dito ah',
    timestamp: yesterday(9, 16),
    type: 'text',
    reactions: []
  },
  {
    id: 'msg-006',
    senderId: 'me',
    replyTo: {
      id: 'msg-004',
      senderId: 'alex',
      text: 'yawa HAHAHAHA sige na kain na tayo',
      timestamp: yesterday(9, 16),
      type: 'text'
    },
    text: '😂😂',
    timestamp: yesterday(9, 18),
    status: 'read',
    type: 'text',
    reactions: []
  },
  {
    id: 'msg-007',
    senderId: 'me',
    text: 'Bitin yarn',
    timestamp: yesterday(9, 19),
    status: 'read',
    type: 'text',
    reactions: []
  },
  {
    id: 'msg-008',
    senderId: 'alex',
    text: 'haha okay lang yan',
    timestamp: yesterday(9, 21),
    type: 'text',
    reactions: []
  },
  {
    id: 'msg-009',
    senderId: 'alex',
    text: 'punta ka dito bukas?',
    timestamp: yesterday(9, 22),
    type: 'text',
    reactions: []
  },
  {
    id: 'msg-010',
    senderId: 'me',
    text: 'baka pwede, depende sa schedule ko',
    timestamp: yesterday(9, 25),
    status: 'read',
    type: 'text',
    reactions: []
  },
  {
    id: 'msg-011',
    senderId: 'me',
    text: 'text kita bukas kung libre ako 👌',
    timestamp: yesterday(9, 25),
    status: 'read',
    type: 'text',
    reactions: [{ emoji: '👍', count: 1, byMe: false }]
  },
  {
    id: 'msg-012',
    senderId: 'alex',
    imageUrl: "https://img.rocket.new/generatedImages/rocket_gen_img_1b8e7aa69-1764728384722.png",
    imageAlt: 'Mobile app prototype screenshot showing a clean onboarding screen with blue gradient and minimal form layout',
    imageWidth: 600,
    imageHeight: 420,
    timestamp: d(62),
    type: 'image',
    reactions: []
  },
  {
    id: 'msg-013',
    senderId: 'alex',
    text: 'ito yung design na ginawa ko kanina, kamusta?',
    timestamp: d(61),
    type: 'text',
    reactions: []
  },
  {
    id: 'msg-014',
    senderId: 'me',
    replyTo: {
      id: 'msg-013',
      senderId: 'alex',
      text: 'ito yung design na ginawa ko kanina, kamusta?',
      timestamp: d(61),
      type: 'text'
    },
    text: 'grabe ganda naman nito! ang galing mo talaga 🔥',
    timestamp: d(45),
    status: 'read',
    type: 'text',
    reactions: [{ emoji: '❤️', count: 1, byMe: false }]
  },
  {
    id: 'msg-015',
    senderId: 'alex',
    text: 'salamat haha maraming revisions pa yan',
    timestamp: d(30),
    type: 'text',
    reactions: []
  },
  {
    id: 'msg-016',
    senderId: 'me',
    text: 'sige padala mo sa akin yung file pag tapos na',
    timestamp: d(18),
    status: 'read',
    type: 'text',
    reactions: []
  },
  {
    id: 'msg-017',
    senderId: 'alex',
    text: 'oo sige, mamaya na pag done na ko',
    timestamp: d(14),
    type: 'text',
    reactions: []
  },
  {
    id: 'msg-018',
    senderId: 'alex',
    text: 'done na ✅ check mo na lang sa email',
    timestamp: d(8),
    type: 'text',
    reactions: [{ emoji: '🙌', count: 1, byMe: true }]
  },
  {
    id: 'msg-019',
    senderId: 'me',
    text: 'nakita ko na, salamat! 🎉',
    timestamp: d(2),
    status: 'read',
    type: 'text',
    reactions: []
  }
];